import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import MobileBottomBar from '../Layout/MobileBottomBar';


function RefundPolicy() {
    const navigate = useNavigate();
    


    return (
        <>
            <section className="modern-page-banner">
                <div className="container">
                    <div className="banner-content">
                        <div className="banner-icon">
                            <i className="fas fa-undo-alt"></i>
                        </div>
                        <h1 className="banner-title">Refunds Policy</h1>
                        <p className="banner-subtitle">Understanding our refund process</p>
                    </div>
                </div>
            </section>

            <section className="modern-content-section">
                <div className="container">
                    <div className="content-wrapper">
                        <div className="intro-section">
                            <div className="intro-card">
                                <p className="intro-text">
                                    At Fynito, customer satisfaction is our priority. Please review our refund
                                    policy below:
                                </p>
                            </div>
                        </div>

                        <div className="policy-section">
                            <div className="policy-card">
                                <div className="section-header">
                                    <div className="section-icon success">
                                        <i className="fas fa-check-circle"></i>
                                    </div>
                                    <h5 className="section-title">Eligibility for Refunds:</h5>
                                </div>
                                <ul className="modern-content-list">
                                    <li>Incorrect orders or items not received.</li>
                                    <li>Orders canceled before restaurant confirmation.</li>
                                </ul>
                            </div>

                            <div className="policy-card">
                                <div className="section-header">
                                    <div className="section-icon warning">
                                        <i className="fas fa-times-circle"></i>
                                    </div>
                                    <h5 className="section-title">Non-Refundable:</h5>
                                </div>
                                <ul className="modern-content-list">
                                    <li>If the order is prepared and dispatched.</li>
                                    <li>Issues arising from user error, such as incorrect address input.</li>
                                </ul>
                            </div>

                            <div className="policy-card highlight-card">
                                <div className="section-header">
                                    <div className="section-icon info">
                                        <i className="fas fa-info-circle"></i>
                                    </div>
                                    <h5 className="section-title">Refund and Return Policy:</h5>
                                </div>
                                <ul className="modern-content-list">
                                    <li>We will not take any returns once the order is delivered</li>
                                    <li>Refunds will be credited within 5-7 business days.</li>
                                    <li>
                                        Contact us at <Link to="mailto:support@fynito.com" className="email-link">support@fynito.com</Link>
                                        with your order details for refund requests.
                                    </li>
                                </ul>
                                
                                <div className="contact-info">
                                    <p className="contact-text">Need help with a refund?</p>
                                    <Link to="mailto:support@fynito.com" className="contact-email">
                                        <i className="fas fa-envelope"></i>
                                        support@fynito.com
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mobile Bottom Bar */}
            <MobileBottomBar />
        </>
    )
}

export default RefundPolicy